import React from "react";
import { FormControlLabelSmall, DarkCheckbox } from "../../../Themes/StyledElements"
import { Grid, FormGroup, Typography } from "@material-ui/core"
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank"
import CheckBoxIcon from "@material-ui/icons/CheckBox"
import { Control, Controller, FormState } from "react-hook-form"

// Fonction pour accéder aux erreurs imbriquées
const getNestedError = (errors: any, name: string) => {
    // Convertir le nom du champ en tableau de clés
    // Par exemple, "spot.productNature" devient ["spot", "productNature"]
    // "works.[0].workCode" devient ["works", "0", "workCode"]
    const keys = name.replace(/\.\[/g, '.').replace(/\]/g, '').split('.');

    // Parcourir l'objet d'erreurs en suivant le chemin des clés
    let current = errors;
    for (const key of keys) {
        if (!current || !current[key]) {
            return undefined;
        }
        current = current[key];
    }

    return current.message;
};

export const FormMultiCheckboxField = ({
    label,
    name,
    control,
    disabled,
    formState,
    required,
    helperText,
    choices,
    onChange
}: {
    label: string,
    name: string,
    control: Control,
    disabled?: boolean,
    formState: FormState<any>,
    required?: boolean,
    helperText?: string,
    choices: { value: string, label: string }[],
    onChange?: () => void
}) => {
    // Récupérer le message d'erreur pour ce champ
    const errorMessage = getNestedError(formState.errors, name);

    return (
        <Grid item container style={{ marginTop: '15px' }}>
            <Grid item xs={2}>
                {label} {required && <span style={{ color: 'red' }}>*</span>}
            </Grid>
            <Grid item xs={10}>
                <Controller
                    control={control}
                    name={name}
                    defaultValue={[]}
                    render={(field) => {
                        const { value = [], onChange: onChangeField } = field;
                        const handleChange = (choiceValue: string) => {
                            if (value.includes(choiceValue)) {
                                onChangeField(value.filter((val: string) => val !== choiceValue));
                            }
                            else {
                                onChangeField([...value, choiceValue]);
                            }
                            onChange?.()
                        };

                        return (
                          <FormGroup row>
                            {choices.map((choice) => (
                              <FormControlLabelSmall
                                key={choice.value}
                                control={
                                  <DarkCheckbox
                                    icon={<CheckBoxOutlineBlankIcon />}
                                    checkedIcon={<CheckBoxIcon />}
                                    checked={value?.includes(choice.value)}
                                    onChange={() => handleChange(choice.value)}
                                    disabled={disabled}
                                  />
                                }
                                label={choice.label}
                              />
                            ))}
                          </FormGroup>
                        );
                    }}
                />
                {errorMessage && <Typography variant="caption" color="error">{errorMessage}</Typography>}
                {!errorMessage && helperText && <Typography variant="caption" color="textSecondary">{helperText}</Typography>}
            </Grid>
        </Grid>
    );
}; 